import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Stack,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import ImageWithFallback from '../../widgets/ImageWithFallback';

const ProductDeleteDialog = ({ open, onClose, product, onSuccess }) => {
    const handleSubmit = async () => {
        try {
            await RequestService.deleteProduct(product.productId);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Failed to delete product:', err);
        }
    };

    if (!product) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ padding: '32px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 24,
                            fontWeight: '500',
                            color: '#0C3466',
                            mb: 3,
                        }}
                    >
                        Excluir Recompensa
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Tem certeza que deseja excluir esta recompensa? Essa
                        ação é irreversível e todos os dados associados a ela
                        serão perdidos.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações da Recompensa
                    </Typography>
                    <Box
                        sx={{
                            padding: '24px 10px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Box
                                sx={{
                                    width: 120,
                                    height: 80,
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    border: '1px solid #E0E0E0',
                                }}
                            >
                                <ImageWithFallback
                                    src={product.photoUrl}
                                    alt={product.name}
                                    fallbackSrc="../../assets/images/gameup_dark.png"
                                    styles={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                            <Stack direction="column" spacing={1}>
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: 14,
                                        fontWeight: '500',
                                        color: '#292929',
                                    }}
                                >
                                    Nome: {product.name}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: 14,
                                        fontWeight: '400',
                                        color: '#666666',
                                    }}
                                >
                                    Descrição:{' '}
                                    {product.description || 'Não informado'}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: 14,
                                        fontWeight: '400',
                                        color: '#292929',
                                    }}
                                >
                                    Preço: {product.price}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="error"
                    variant="contained"
                >
                    Excluir Recompensa
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProductDeleteDialog;
